export const Bio = {
  name: "Gaspar Dantas Junior",
  roles: [
    "am a Data Analyst",
    "am a Software Developer",
    "am an Automation Engineer",
    "am a UCF Student",
    "am a Computer Science Major",
    "will graduate in May 2027",
  ],
  description:
    "I am a Computer Science student at the University of Central Florida with professional experience across software development, data analysis, and industrial automation. Most recently, I completed an Automation Engineering internship at Amazon, where I supported automated conveyor and sortation systems through troubleshooting, root cause analysis, SCADA development, and continuous process improvement. Previously, at Lockheed Martin, I contributed to software development and data analysis initiatives, gaining experience working with engineering teams and developing solutions to improve processes and reporting. I enjoy solving complex problems, learning across technical disciplines, and applying technology to create measurable improvements. As I continue toward graduation, I am focused on expanding my engineering experience and preparing for the next stage of my career.",
  github: "https://github.com/gaspardantas",
  resume: "/resume.pdf",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      /* {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      }, */
      /* {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      }, */
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },

      /* {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      }, */
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "PHP",
        image: "https://www.php.net/images/logos/new-php-logo.svg",
      },
      /*  {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      }, */
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      /*  {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      }, */
      /*  {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      }, */
      /* {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      }, */
    ],
  },
  {
    title: "Data Analysis",
    skills: [
      {
        name: "Tableau",
        image:
          "https://help.tableau.com/current/online/en-us/Resources/tableau-logo.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MS Excel",
        image:
          "https://cdn-dynmedia-1.microsoft.com/is/image/microsoftcorp/Blade005_3-Up%20Icon%20Card_Excel_24x22_2x?resMode=sharp2&op_usm=1.5,0.65,15,0&wid=64&hei=64&qlt=100&fmt=png-alpha&fit=constrain",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      /* {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      }, */
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "MATLAB",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Matlab_Logo.png/1340px-Matlab_Logo.png",
      },
      /* {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      }, */
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/120px-ISO_C%2B%2B_Logo.svg.png",
      },
      /* {
        name: "Adobe XD",
        image:
          "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      }, */
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
];

export const experiences = [
  /* {
    id: 0,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKskHlCJIoFiJQBLkGBBq8VPHcLz-vHDuLdQ&s",
    role: "Business Owner",
    company: "Atos Orlando",
    date: "Dec 2017 - Dec 2023",
    desc:
      "Led team-building activities and maintained strong customer relations while identifying new market opportunities and forging strategic partnerships. I optimized inventory control and managed finances efficiently, driving sustainable growth. Additionally, I spearheaded successful marketing strategies, boosting brand visibility and attracting new customers.",
    skills: [
      "Problem Solving",
      "Management",
      "Customer Satisfaction",
      "Leadership",
      "Training",
      "Multitasking",
      "Payroll",
      "Conflict Resolution",
      "Sales",
      "Communication",
      "Teamwork",
    ],
    /*     doc:
      "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ", */
  //}, //*/
  {
    id: 1,
    img:
      "https://www.logogenie.com/images/articles/amazon-logo-a-brief-logo-history-and-what-makes-it-so-special/image8.jpg",
    role: "Automation Engineer",
    company: "Amazon",
    date: "Jun 2026 - Aug 2026",
    desc: "Analyzed automation and downtime data by extracting, cleaning, and reporting sensor and jam events to identify high impact failure points, locate responsible equipment, and support repairs and replacements that contributed to an approximately 46% reduction in facility downtime. Completed the facility’s Ignition rollout, developing dozens of SCADA pages, including live dashboards with hundreds of tag connections that provided Operations and RME teams with real time visibility into equipment status, performance metrics, E Stops, and system issues. Created dozens of Amazon Wiki pages with technical instructions for RME personnel, improved Tech Drill documentation, and trained personnel on installing and using AI tools to optimize workflows, strengthen knowledge sharing, and improve task execution.",
    skills: [
      "Problem Solving",
      "Software Development",
      "Dashboard Creation",
      "Multitasking",
      "Data Analysis",
      "Attention to Detail",
      "Ignition",
      "SCADA dashboards",
      "Hands on replacing equipments",
      "Communication",
    ],
  },
  {
    id: 2,
    img:
      "https://lockheedmartin.com/content/dam/lockheed-martin/general/lm-logo.svg",
    role: "Software Developer/Data Analyst",
    company: "Lockheed Martin(UCF CWEP)",
    date: "Jul 2025 - Jun 2026",
    desc: "Developed dashboards and performed data analysis to support clearer reporting and better decision making, while also automating reporting processes with Excel and C#, reducing manual processing time by 50 percent. To improve consistency and efficiency, I wrote small scripts to standardize report outputs and reduce repetitive manual work. I also collaborated with cross functional teams using Git and Jira to track tasks, manage updates, and help ensure accuracy, quality, and alignment across deliverables.",
    skills: [
      "Problem Solving",
      "Software Development",
      "Dashboard Creation",
      "Multitasking",
      "Data Analysis",
      "Attention to Detail",
      "Communication",
    ],
  },
  /* 
  {
    id: 3,
    img: "https://bestbonitacleaning.com/images/logo.png",
    role: "Operations Manager",
    company: "Best Bonita Cleaning Corporation",
    date: "Jan 2024 - Dec 2024",
    desc:
      "Scheduled and coordinated appointments, optimizing staff routes for efficiency. Developed and maintained Google Spreadsheets to track jobs, routes, and payment status. Improved workflow by identifying and implementing process and scheduling efficiencies. Supported remote business operations with strong attention to detail and time management.",
    skills: [
      "Problem Solving",
      "Management",
      "Leadership",
      "Multitasking",
      "Dashboard Creation",
      "Attention to Detail",
      "Communication",
    ],
  },*/
  {
    id: 3,
    img: "https://ok2static.oktacdn.com/fs/bco/1/fs012rh65w9Nu6vA40x8",
    role: "Operations Manager",
    company: "Sunrun",
    date: "May 2020 - Apr 2023",
    desc:
      "Progressively advanced through roles that included system installation, team leadership, rooftop project supervision, electrical system oversight, construction management, and operational coordination. Contributions to increased project efficiency, reduced operational downtime, and improved overall performance across company operations. Gained expertise in troubleshooting complex systems, analyzing operational data, and adapting to evolving technologies. Resulting in more efficient installations, reduced system downtime, and higher quality results that improved overall project success and client satisfaction. Led and collaborated with cross-functional teams, enhancing alignment, team efficiency, and stakeholder communication, contributing to stronger project outcomes and overall organizational success.",
    skills: [
      "Problem Solving",
      "Management",
      "Customer Satisfaction",
      "Leadership",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Conflict Resolution",
      "Safety",
      "Training",
      "Teamwork",
    ],
    /* doc:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:AN…OSh4p_qDDnu9HA_8C7ayZwnPW1oqc1OaT6DFRKRE&usqp=CAU", */
  },
  /*  {
    id: 2,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT3dKEAPZX7QA4omHie6QoWhoJtZKNklTRqg&s",
    role: "Construction Supervisor",
    company: "Sunnrun",
    date: "Aug 2022 - Mar 2022",
    desc:
      "Supervised crew members to ensure efficient task completion in adherence to company standards. Enforced rigorous worksite safety protocols to mitigate hazards and ensure a secure environment. Implemented stringent quality control measures to uphold superior workmanship and material standards. Successfully managed multiple construction projects from initiation to completion within designated timelines. Ensured full compliance with construction regulations and guidelines to prevent penalties or delays.",
    skills: [
      "Problem Solving",
      "Management",
      "Customer Satisfaction",
      "Leadership",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Safety",
      "Training",
      "Teamwork",
    ],
  },
  {
    id: 3,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT3dKEAPZX7QA4omHie6QoWhoJtZKNklTRqg&s",
    role: "Foreperson",
    company: "Sunrun",
    date: "Mar 2021 - Aug 2021",
    desc:
      "With adept leadership, I've overseen successful project deliveries on schedule. I prioritize clear communication, efficient planning, and adherence to safety regulations, optimizing resource allocation and workflow. My focus on equipment maintenance ensures uninterrupted operations and consistently high-quality outcomes.  Supervised construction activities to ensure efficient workflow and consistently achieved high-quality results.",
    skills: [
      "Problem Solving",
      "Management",
      "Customer Satisfaction",
      "Leadership",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Safety",
      "Training",
      "Teamwork",
    ],
    /* doc:
      "https://drive.google.com/file/d/1mkh7CuRMwML7cXmgJwk2D0lw1dHniKZf/view?usp=drive_link", */

  /*   {
    id: 4,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT3dKEAPZX7QA4omHie6QoWhoJtZKNklTRqg&s",
    role: "Team Lead",
    company: "Sunrun",
    date: "Oct 2020 - Mar 2021",
    desc:
      "As a seasoned team leader, I established clear and attainable objectives, effectively managed a diverse team by delegating tasks and offering guidance, resolved conflicts through open communication and collaborative problem-solving, coordinated multiple tasks concurrently to meet deadlines, objectively evaluated team performance and provided constructive feedback, maintained transparent communication with customers during installations, and adeptly handled wiring and electrical components of solar energy systems.",
    skills: [
      "Problem Solving",
      "Customer Satisfaction",
      "Leadership",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Safety",
      "Wiring the System",
      "Teamwork",
    ],
  }, */
  /* {
    id: 5,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT3dKEAPZX7QA4omHie6QoWhoJtZKNklTRqg&s",
    role: "Solar Installer",
    company: "Sunrun",
    date: "May 2020 - Oct 2020",
    desc:
      "Ensured strict compliance with roof safety protocols during solar panel installations, adhered to established guidelines and quality standards. This contributed to delivering reliable solar solutions for homeowners, positively impacting their energy efficiency and sustainability goals.",
    skills: [
      "Problem Solving",
      "Customer Satisfaction",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Safety",
      "Teamwork",
    ],
  }, */
  /* {
    id: 6,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgSdaLrr4tkMpQRhcAHjkiUZUVJc1FQC5OOg&s",
    role: "General Manager",
    company: "NQ General Services",
    date: "Jun 2018 - May 2021",
    desc:
      "Led a dynamic team to attain targeted goals and maximize performance. Developed and implemented customized staff development programs to enrich skills and knowledge. Managed financial resources efficiently to meet budget objectives. Formulated strategic plans to foster long-term organizational growth. Enhanced operational efficiency through process streamlining and workflow enhancements. Cultivated robust client relationships to boost customer satisfaction and loyalty.",
    skills: [
      "Problem Solving",
      "Management",
      "Customer Satisfaction",
      "Leadership",
      "Multitasking",
      "Attention to Detail",
      "Communication",
      "Safety",
      "Training",
      "Teamwork",
    ],
  }, */
  /*{
     id: 7,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfdz6xjAQ5fIXch_rttxSd_BdsB-ApGpXTRQ&s",
    role: "Junior Data Analyst and Junior Reasercher",
    company: "Petrobras",
    date: "Jan 2012 - Jan 2014",
    desc:
      "Analyzed large datasets, extracted valuable insights and trends, and conducted experiments using various lab techniques. Detailed reports were generated to outline research findings and recommendations, supported by in-depth literature reviews. Project timelines, budgets, and resources were managed effectively, with statistical analysis performed on research data to draw meaningful conclusions.",
    skills: [
      "Programming",
      "MATLAB",
      "Data Analysis",
      "Collaboration",
      "Research",
      "Presentation",
      "Communication",
    ],
  }, */
];

export const education = [
  /* {
    id: 0,
    img:
      "https://seeklogo.com/images/U/unp-universidade-potiguar-logo-E3BD6BDA9B-seeklogo.com.png",
    school: "UnP - Universidade Potigual",
    date: "Jan 2008 - Dec 2011",
    grade: "3.6 GPA",
    desc:
      "I have successfully completed my degree in Computer Engineering with a focus on control automation and programming. U.S. equivalent to Bachelor of Science in Computer Engineering from a regionally accredited Institution of higher education, based on evaluation from a member of the Association of International credential Evaluators (AICE).",
    degree: "Bachelor of Science - BSc, Computer Engineering",
  }, */
  /*   {
    id: 1,
    img: "https://seeklogo.com/images/U/ufrn-logo-EEBB3B5235-seeklogo.com.png",
    school: "UFRN - Universidade Federal do Rio Grande do Norte",
    date: "Jan 2012 - Jan 2014",
    grade: "4.0 GPA",
    desc:
      "I have successfully completed my Master's degree in Computer Engineering with a specialization in control automation and programming. U.S. equivalent to Master of Science in Electrical and Computer Engineering from a regionally accredited Institution of higher education, based on evaluation from a member of the Association of International credential Evaluators (AICE).",
    degree: "Master of Engineering - MEng, Computer and Electrical Engineering",
  }, */
  {
    id: 0,
    img:
      "https://1000logos.net/wp-content/uploads/2017/11/Color-University-Central-Florida-Logo.jpg",
    school: "UCF - University of Central Florida",
    date: "May 2027",
    grade: "3.9 GPA",
    desc:
      "Minoring in Data Science and Mathematics, with a strong focus on the connection between computing, software development, data analysis, and logical reasoning. This academic foundation strengthens my analytical thinking and problem solving skills, allowing me to approach real world challenges with both technical depth and a data driven perspective.",
    degree: "Bachelor of Science in Computer Science",
  },
  {
    id: 2,
    img:
      "https://valenciacollege.edu/android-chrome-512x512.png",
    school: "VC - Valencia College",
    date: "Aug 2023",
    grade: "4.0 GPA",
    desc:
      "Graduated with a focus on programming principles, software development, and problem-solving. Proficient in languages such as JavaScript, HTML, CSS, and Python, with a solid understanding of object-oriented programming, data structures, and database management. Gained practical experience through hands-on projects and coursework in web development, and software engineering. Preparing for further studies and professional work in computer programming and analysis.",
    degree: "Associate of Science in Computer Programming and Analysis",
  },
  /* {
    id: 3,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKyacXxe-Ga7h0XvHus9nuzMSE2bJK0lwgaQ&s",
    school: "VC - Valencia College",
    date: "Jan 2012 - Jan 2014",
    grade: "4.0 GPA",
    desc:
      "This certificate prepares students with foundation skills in computer maintenance, network essentials and database.",
    degree:
      "Technical Certificate - Cert., Computer Information Data Specialist",
  }, */
  /*{
    id: 4,
    img:
      "https://valenciacollege.edu/android-chrome-512x512.png",
    school: "VC - Valencia College",
    date: "Dec 2024",
    grade: "4.0 GPA",
    desc:
      "This certificate prepares students with foundation skills in software development. The content includes developing software solutions, and writing computer programs to meet customer needs and requirements.",
    degree:
      "Technical Certificate - Cert., Web Development and Computer Programming Specialization",
  },
  {
    id: 4,
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf8ZwQVJ4EjnO8oWqjAZGEy-IbyqfLCcmYHg&s",
    school: "AWS - Amazon Web Services",
    date: "Aug 2023",
    grade: "PASS",
    desc:
      "Earning this certification validates high-level understanding of AWS Cloud, services, and terminology. This certification serves as an entry point to a cloud career for candidates from non-IT backgrounds switching to cloud.",
    degree: "AWS Certified Cloud Practitioner",
  },
 {
    id: 2,
    img:
      "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Methodist School, Dankuni",
    date: "Apr 2017 - Apr 2019",
    grade: "92.3%",
    desc:
      "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  }, */
];

export const projects = [
  {
    id: 5,
    title: "Florida Criminal Traffic Statistics Analysis",
    date: "Apr 2024",
    description:
      "The Florida Criminal Traffic Statistics Analysis project aims to provide in-depth insights into the enforcement and supervision efforts of agencies overseeing criminal traffic citations in Florida. By analyzing datasets sourced from the Florida Department of Highway Safety and Motor Vehicles (FLHSMV) spanning from 2011 to 2023, our project endeavors to uncover comprehensive trends and patterns related to criminal traffic citations. Through rigorous examination of these datasets, we seek to shed light on the classification of violations, identify key agencies responsible for enforcement, and highlight temporal trends and variations in citation rates. Our ultimate goal is to offer valuable insights that can inform policy decisions, enhance enforcement strategies, and contribute to promoting safety on Florida's roadways.",
    image:
      "https://qph.cf2.quoracdn.net/main-qimg-29969cd0fe35da6a68620b9e1dd73889-lq",
    tags: ["Tableau Public Dashboard"],
    category: "data analysis",
    github: "https://github.com/gaspardantas",
    webapp:
      "https://public.tableau.com/app/profile/gaspar.dantas/viz/FloridaCriminalTrafficCitationsStatistics2011to2023/Dashboard1?publish=yes",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
      /* {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com",
        linkedin: "https://www.linkedin.com/in",
        github: "https://github.com/bradleydantas",
      }, */
    ],
  },
  {
    id: 0,
    title: "Florida Housing Market Analysis",
    date: "Apr 2024",
    description:
      "The Florida Housing Market Analysis project is dedicated to exploring the impact of mortgage rates on housing inventory and pricing trends across Florida. Through rigorous analysis of datasets sourced from the Federal Reserve Economic Data (FRED), including vital indicators like Florida Median Listing Price, US Mortgage Average, and Housing Inventory in Florida, our endeavor is to reveal comprehensive insights into the intricate dynamics governing the Florida housing market.",
    image:
      "https://cdn.ramseysolutions.net/media/blog/home-buying/home-buying-basics/florida-housing-market.jpg",
    tags: ["Python"],
    category: "data analysis",
    github: "https://github.com/gaspardantas",
    webapp: "N/A",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
      /* {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com",
        linkedin: "https://www.linkedin.com/in",
        github: "https://github.com/bradleydantas",
      }, */
    ],
  },
  {
    id: 4,
    title: "MemoryGame",
    date: "Apr 2024",
    description:
      "Built in React with styled-components and browser storage, this 6x6 memory challenge uses 18 random playing-card pairs. Players enter their name, track mistakes, save the top 3 best scores with timestamps, and replay against a freshly shuffled board. Live locally at /mg for a faster, more polished experience.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAIAWSZ1_ppjACJBOtT724x1KZiw2WYMeUxw&s",
    tags: ["React", "JavaScript", "Styled Components", "LocalStorage", "Web Game"],
    category: "web game",
    github: "https://github.com/gaspardantas/portfolio/blob/main/src/components/Games/MemoryGame.jsx",
    webapp: "/mg",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
      /* {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com",
        linkedin: "https://www.linkedin.com/in",
        github: "https://github.com/bradleydantas",
      }, */
    ],
  },
  {
    id: 3,
    title: "Rock Paper Scissors",
    date: "Apr 2024",
    description:
      "React-powered Rock Paper Scissors with a personalized start screen and fun commentary. Enter your name, choose your move, and see whether the machine wins, a tie occurs, or the human takes the round. Live locally at /rps so you can play instantly without an S3 bucket.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpI_AwlQLSQdjWempnmTss2UlTesGVSaOTvg&s",
    tags: ["React", "JavaScript", "Styled Components", "Web Game"],
    category: "web game",
    github: "https://github.com/gaspardantas/portfolio/blob/main/src/components/Games/RockPaperScissors.jsx",
    webapp: "/rps",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
      /* {
        name: "Bradley Dantas",
        img: "",
        linkedin: "",
        github: "",
      }, */
    ],
  },
  {
    id: 2,
    title: "pythonWeather Project",
    date: "Apr 2024",
    description:
      "To leverage Python's versatility and Flask's simplicity to develop a dynamic web application for retrieving and displaying real-time weather information, catering to users' need for instant weather updates.  By utilizing Python's powerful libraries and frameworks, particularly Flask, we seamlessly integrated backend functionality with front-end design, enabling users to input their desired city and receive accurate weather data in a visually appealing format.  This project encompasses a Python-based web application built using Flask, offering a user-friendly interface to access weather information for any major city. Leveraging the power of Python, HTML, CSS, and Flask, we've created an efficient and reliable solution for retrieving live weather data and deploying it on an instance server for seamless accessibility.",
    image:
      "https://kashmirage.net/wp-content/uploads/2020/04/Weather-Kasmir-Age.jpg",
    tags: ["Python", "Flask", "CSS", "HTML"],
    category: "web app",
    github: "https://github.com/gaspardantas",
    webapp: "https://pythonweather-89j5.onrender.com/",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
    ],
  },
  {
    id: 1,
    title: "Mini Sudoku",
    date: "Mar 2026",
    description:
      "A fully playable 6×6 Mini Sudoku built in React. Uses numbers 1–6 with three constraints: each row, each column, and each 3-col × 2-row box must contain 1–6 exactly once (6 boxes total). Puzzles are generated via MRV backtracking to guarantee a unique solution. Features difficulty selection (Easy/Medium/Hard), player name entry, real-time mistake counter, timer, pencil-mark notes mode, and per-difficulty top-3 leaderboards saved in localStorage. Mobile-first layout fits any phone screen.",
    image: "/minisudoku-preview.svg",
    tags: ["React", "JavaScript", "Styled Components", "LocalStorage", "Web Game"],
    category: "web game",
    github:
      "https://github.com/gaspardantas/portfolio/blob/main/src/components/Games/MiniSudoku.jsx",
    webapp: "/sudoku",
    member: [
      {
        name: "Gaspar Dantas",
        img: "https://avatars.githubusercontent.com/u/106454643?v=4",
        linkedin: "https://www.linkedin.com/in/gaspar-fontineli/",
        github: "https://github.com/gaspardantas",
      },
    ],
  },
  /*   {
    id: 4,
    title: "Test",
    date: "Dec 2021 - Apr 2022",
    description:
      "App Is Currently ...",
    image:
      "https://webapp",
    tags: ["Google Drive Cloud API"],
    category: "android app",
    github: "https://github.com/",
    webapp: "https://webapp",
  }, */
];

export const TimeLineData = [
  { year: 2026, text: "BS" },
  { year: 2023, text: "AS" },
  { year: 2019, text: "TC" },
];
